// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.pc-none{
    display: none !important;
}
.pc-flex{
    display: flex !important;
}
.pc-block{
    display: block !important;
}
.pc-inline-block{
    display: inline-block !important;
}

@media screen and (max-width: 1024px) {

    .mobile-flex {
        display: flex !important;
    }
    .mobile-block {
        display: block !important;
    }
    .mobile-inline-block {
        display: inline-block !important;
    }
    .mobile-inlinw-block {
        display: block !important;
    }
    .mobile-none{
        display: none !important;
    }

}
`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/mobile.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gCAAgC;AACpC;;AAEA;;IAEI;QACI,wBAAwB;IAC5B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,gCAAgC;IACpC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;;AAEJ","sourcesContent":["@charset \"UTF-8\";\n\n.pc-none{\n    display: none !important;\n}\n.pc-flex{\n    display: flex !important;\n}\n.pc-block{\n    display: block !important;\n}\n.pc-inline-block{\n    display: inline-block !important;\n}\n\n@media screen and (max-width: 1024px) {\n\n    .mobile-flex {\n        display: flex !important;\n    }\n    .mobile-block {\n        display: block !important;\n    }\n    .mobile-inline-block {\n        display: inline-block !important;\n    }\n    .mobile-inlinw-block {\n        display: block !important;\n    }\n    .mobile-none{\n        display: none !important;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
